import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

import Select from '../../form/Select'
import Input from '../../form/Input'
import Panel from '../../../UniformComponents/Panel'
import Button from '../../../UniformComponents/Button'

const CrossBreakSubQuestion = (props) => {
    const {
        crossBreakSubRankingOptions,
        presentationStore,
        index,
        subQuestion,
        removeSubQuestion,
    } = props

    const { crossBreakSubQuestionOptions } = presentationStore

    const onBlur = ({ name, value }) => {
        subQuestion[name] = value
    }

    return (
        <div>
            <Panel cssClass="crossbreak-sub-question-upper-panel">
                <b>
                    {i18n.t('question')}
                    {' '}
                    {index + 1}
                </b>
                <Button
                    label={i18n.t('delete')}
                    icon="fa-regular fa-circle-xmark"
                    onClick={() => removeSubQuestion(subQuestion)}
                    cssClass="crossbreak-btns-delete"
                />
            </Panel>
            <Panel cssClass="crossbreak-sub-question-bottom-panel">
                <Fragment>
                    <div style={{ width: '100%' }}>
                        <Select
                            name="pageQuestionId"
                            label={i18n.t('powerpoint.labels.crossBreakSubQuestion')}
                            options={crossBreakSubQuestionOptions}
                            onBlur={onBlur}
                            defaultValue={subQuestion.pageQuestionId}
                        />
                    </div>
                    <div style={{ width: '100%' }}>
                        <Select
                            name="ranking"
                            label={presentationStore.getSelectLabel('ranking')}
                            options={crossBreakSubRankingOptions}
                            onBlur={onBlur}
                            defaultValue={subQuestion.ranking}
                        />
                    </div>
                    <div style={{ width: '100%' }}>
                        <Input
                            defaultValue={parseInt(subQuestion.removeBaseLimit, 10)}
                            name="removeBaseLimit"
                            type="number"
                            onBlur={onBlur}
                            label={i18n.t('powerpoint.labels.removeBaseLimit')}
                            cssClass="number-input hover-style"
                        />
                    </div>
                </Fragment>
            </Panel>
        </div>
    )
}

CrossBreakSubQuestion.propTypes = {
    subQuestion: PropTypes.object.isRequired,
    removeSubQuestion: PropTypes.func.isRequired,
    crossBreakSubRankingOptions: PropTypes.array.isRequired,
    presentationStore: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
}

export default CrossBreakSubQuestion
